'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var createTypography = {};

exports.__exports = createTypography;
